import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Sandbox, SandboxStatus } from '../../types/sandbox';

interface StatusDistributionChartProps {
  sandboxes: Sandbox[];
}

const STATUS_COLORS: Record<SandboxStatus, string> = {
  pending: '#d9d9d9',
  creating: '#1677ff',
  ready: '#52c41a',
  failed: '#ff4d4f',
  deleting: '#faad14',
};

export const StatusDistributionChart: React.FC<StatusDistributionChartProps> = ({ sandboxes }) => {
  // Count sandboxes by status
  const statusCounts: Record<string, number> = {};

  sandboxes.forEach((sandbox) => {
    const status = sandbox.status;
    statusCounts[status] = (statusCounts[status] || 0) + 1;
  });

  // Transform to chart data
  const data = Object.entries(statusCounts).map(([status, count]) => ({
    name: status.charAt(0).toUpperCase() + status.slice(1),
    value: count,
    status: status as SandboxStatus,
  }));

  if (data.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0', color: '#8c8c8c' }}>
        No data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          outerRadius={80}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((entry) => (
            <Cell key={`cell-${entry.name}`} fill={STATUS_COLORS[entry.status]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};
